exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label>span[data-v-ecbba00c]{margin-left:4px;color:#e23e1d}", ""]);

// exports
